import React from 'react';
import './driverDobPicker.css';
import CalendarIcon from '@mui/icons-material/CalendarMonth';

function NativeDatePicker({ date, setDate, width }) {
  // This function formats the date from "YYYY-MM-DD" to a readable format
  const formatDate = (dateString) => {
    if (!dateString) return '';
    // We split the string and rearrange it. Add 1 day to correct timezone issues.
    const dateObj = new Date(dateString + 'T00:00:00');
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return dateObj.toLocaleDateString('en-US', options); // e.g., "August 30, 2025"
  };

  const handleDateChange = (e) => {
    setDate(e.target.value);
  };

  return (
    <div style={{ width }} className="date-picker-container">
      <label htmlFor="birthdate" className="date-picker-label">
        <div className="calendar-icon">
          <CalendarIcon />
        </div>

        {/* We now use a single element for the text */}
        <span className="text-element">
          {date ? formatDate(date) : "Enter Driver's Date Of Birth"}
        </span>

        <input
          type="date"
          id="birthdate"
          value={date}
          onChange={handleDateChange}
          className="date-input"
        />
      </label>
    </div>
  );
}

export default NativeDatePicker;
